import { Download, Upload } from "lucide-react";

// Button colour = what pressing it does.
export const BTN = {
  data: "bg-brand text-white hover:bg-brand-hover border border-transparent",            // in / out: upload, download, import, export, print, push, email send
  write: "bg-emerald-600 text-white hover:bg-emerald-700 border border-transparent",       // writes a record: save, add, confirm, approve, complete
  mode: "border border-emerald-600 bg-transparent text-emerald-700 hover:bg-emerald-50",  // opens a mode that ends in a green write
  nav: "border border-slate-300 bg-transparent text-slate-800 hover:bg-slate-50",         // moves you: view, pdf, preview, back, expand
  internal: "bg-slate-200 text-slate-800 hover:bg-slate-300 border border-transparent",   // moves internally, writes nothing: email composer (mailto), paste
  danger: "bg-red-600 text-white hover:bg-red-700 border border-transparent",              // destructive — confirm dialogs only
};
// Toolbar size.
export const BTN_SM = "inline-flex h-7 items-center gap-1 rounded-md px-2.5 text-xs font-medium disabled:opacity-50 disabled:pointer-events-none";
export const btn = (kind) => `${BTN_SM} ${BTN[kind] || BTN.nav}`;
// Direction is from the USER'S DEVICE: Upload (arrow up) = a file goes into the app; Download (arrow down) = a file comes out.
export const ICON = { upload: Upload, download: Download };
